module.exports = __webpack_public_path__ + "media/wyposazenie/bezpieczenstwo@2x-9ddf9532.png";